import { toParagraphsArray, toParagraphsString } from '~/utilities/paragraphs';

export default {
    methods: {
        paragraphs (value) {
            return toParagraphsArray(value);
        },

        paragraphsEditable (value) {
            return toParagraphsString(value);
        },
    },
};
